module.exports = __webpack_public_path__ + "media/assets/svgs/question-20350cfb64ca9f4b08e99484f5d78131.svg";